// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"f8a203cb","64":"447290f8","92":"5bb2811b","115":"4e80ba7e","168":"829ae2a6","440":"5b0b8aab","504":"1ee2ce90","592":"cf80d4fc","732":"b21d7d83","812":"78c34eec","892":"280efc01"}[chunkId] + ".chunk.js";
};